import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { headerStrategies } from "./headers";

export const baseQuery = (baseUrl, type = "json", resType = "json") => {
  return resType === "blob"
    ? fetchBaseQuery({
        baseUrl,
        prepareHeaders: headerStrategies[type],
        responseHandler: async (res) => res.blob(),
      })
    : fetchBaseQuery({
        baseUrl,
        prepareHeaders: headerStrategies[type],
      });
};
